/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const BroomSolidV6 = (props) => (
  <Icon {...props} name="Broom Solid V6">
    <path d="M2.328 8.043c-.547.435-1.003 1.395-1.363 2.435l1.509-.55c.144-.053.265.119.166.237L.274 12.968c-.181.785-.275 1.387-.275 1.387s5.165.341 6.665-.853C8.164 12.305 8.58 9.75 8.58 9.75L6.412 7.018s-2.585-.19-4.084 1.025zM15.83 1.909a.802.802 0 0 0-1.123-.141l-5.643 4.39-.875-1.101a.276.276 0 0 0-.465.056l-.63 1.34 2.169 2.73 1.469-.313a.273.273 0 0 0 .159-.437l-.83-1.045 5.63-4.38c.348-.248.41-.751.138-1.099z" />
  </Icon>
);

export default BroomSolidV6;
